import { parseUnit, parsedUnitToSymbol } from '@izho-ts/lib-unit/converter'

export const isParsable = (unit: string): boolean => {
  try {
    parseUnit(unit)
    return true
  } catch {
    return false
  }
}

export const toSymbol = (unit: string): string => isParsable(unit)
  ? parsedUnitToSymbol(parseUnit(unit))
  : unit
